export default __webpack_public_path__ + "static/media/015.0ee80478.webp";